import { render, staticRenderFns } from "./Ruleta.vue?vue&type=template&id=fba7e030&"
import script from "./Ruleta.vue?vue&type=script&lang=js&"
export * from "./Ruleta.vue?vue&type=script&lang=js&"
import style0 from "./Ruleta.vue?vue&type=style&index=0&id=fba7e030&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports